const isOneOf = (value: any, others: any[]): boolean => {
  return others.includes(value)
}
// typescript's Array.includes type is too narrow, making it complain about stuff like [1,2,3].includes(bla?.value)
// this helper function is just an "any"-fied wrapper around it.
export default isOneOf
